import { render, staticRenderFns } from "./NPagination.vue?vue&type=template&id=2637fc16"
import script from "./NPagination.vue?vue&type=script&lang=js"
export * from "./NPagination.vue?vue&type=script&lang=js"
import style0 from "./NPagination.vue?vue&type=style&index=0&id=2637fc16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports